<div mat-dialog-content>
    <div class="mat-dialog-content">
        <h1 >Que tipo de relatório gostaria de criar?</h1>
        <div class="options-container">
            <div (click)="chooseExternal()" class="option">
                <h2>Externo</h2>
            </div>
            <div (click)="chooseInternal()" class="option">
                <h2>Interno</h2>
            </div>
        </div>
    </div>
</div>